module.exports = __webpack_public_path__ + "static/the-mom-factor-8b55692fc6849c4b2068767aa361dc8e.jpg";